import { AlignLeft, AlignCenter, AlignRight, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { MediaAlign } from './mediaAlign'

// Hover control strip for media NodeViews (image, video). Because the video
// iframe is interactive (plays in-editor), we can't rely on click-to-select —
// these controls live on the node itself: align + delete, no selection needed.
const ALIGNS: { value: MediaAlign; icon: typeof AlignLeft; label: string }[] = [
  { value: 'left', icon: AlignLeft, label: 'Align left' },
  { value: 'center', icon: AlignCenter, label: 'Align center' },
  { value: 'right', icon: AlignRight, label: 'Align right' },
]

interface MediaControlsProps {
  align: MediaAlign
  onAlign: (align: MediaAlign) => void
  onDelete: () => void
  deleteLabel: string
}

export function MediaControls({ align, onAlign, onDelete, deleteLabel }: MediaControlsProps) {
  return (
    <div
      contentEditable={false}
      className="absolute right-1.5 top-1.5 z-10 hidden items-center gap-0.5 rounded-md border border-border bg-background/90 p-0.5 shadow group-hover:flex"
    >
      {ALIGNS.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          type="button"
          aria-label={label}
          title={label}
          onClick={event => { event.stopPropagation(); onAlign(value) }}
          className={cn(
            'flex size-6 cursor-pointer items-center justify-center rounded hover:bg-muted',
            align === value && 'bg-muted text-primary',
          )}
        >
          <Icon className="size-3.5" />
        </button>
      ))}
      <span className="mx-0.5 h-4 w-px bg-border" />
      <button
        type="button"
        aria-label={deleteLabel}
        title={deleteLabel}
        onClick={event => { event.stopPropagation(); onDelete() }}
        className="flex size-6 cursor-pointer items-center justify-center rounded hover:bg-destructive hover:text-destructive-foreground"
      >
        <X className="size-3.5" />
      </button>
    </div>
  )
}
